import { Chip } from "@mui/material";
import { eventStatusLabel, isCancelledEvent } from "../../utils/methods/eventPresentation";
import type { EventPresentationState } from "../../utils/methods/eventPresentation";

/** An explicit cancellation label for event lists without a dedicated status column. */
export default function EventCancellationBadge({ event }: { event?: EventPresentationState | null }) {
  if (!isCancelledEvent(event)) return null;
  return (
    <Chip
      component="span"
      label={eventStatusLabel(event)}
      size="small"
      variant="outlined"
      sx={{ ml: 1, flexShrink: 0, color: "#ffffff", borderColor: "#D175B6", fontWeight: 600 }}
    />
  );
}
